import { render } from "./createForm.vue?vue&type=template&id=0a1fb3cd&scoped=true"
import script from "./createForm.vue?vue&type=script&lang=js"
export * from "./createForm.vue?vue&type=script&lang=js"

import "./createForm.vue?vue&type=style&index=0&id=0a1fb3cd&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1fb3cd"]])

export default __exports__